import React from 'react';
export default function ClearRefinements({ clearRefinements, clearRefinementsSettings, }) {
    var _a;
    const { canRefine, refine } = clearRefinements;
    const { translations, classNames } = clearRefinementsSettings;
    if (!canRefine) {
        return null;
    }
    return (React.createElement("button", { className: `clear-refinements ${(classNames === null || classNames === void 0 ? void 0 : classNames.button) || ''}`, type: "button", onClick: refine }, (_a = translations === null || translations === void 0 ? void 0 : translations.clearAll) !== null && _a !== void 0 ? _a : 'Clear all'));
}
